import React from 'react';
import CommunitiesList from './CommunitiesList';
import { Box, Divider, Switch, Typography } from '@mui/material';

import ChatbotSettingsForm from './ChatbotSettingsForm';
import { useChatbotSettingsContext } from '../../utils/ContextProviders/ChatbotSettingsContextProvider';
import { VIEW_TYPES } from './utils';
import ChatbotScript from './ChatbotScript';
const ChatbotSettingsComponent = () => {
  const { communities, view, usePresetSettings, setUsePresetSettings } =
    useChatbotSettingsContext();
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 3,
        backgroundColor: 'background.paper',
        padding: '20px 0 20px 20px',
        height: 'calc(100vh - 200px)'
      }}
    >
      <CommunitiesList />
      <Divider orientation="vertical" flexItem />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          flex: 1,
          overflowY: 'auto'
        }}
      >
        {view.view === VIEW_TYPES.PRESET_CHATBOT_SETTINGS ? (
          <Typography variant="h5" sx={{ mt: 0 }}>
            Preset Chatbot Settings
          </Typography>
        ) : (
          <Typography variant="h5" sx={{ mt: 0 }}>
            {view.communityName} Chatbot Settings
          </Typography>
        )}
        {view.view === VIEW_TYPES.COMMUNITY_CHATBOT_SETTINGS && (
          <div style={{ marginBottom: '8px' }}>
            <Switch
              checked={usePresetSettings}
              onChange={e => setUsePresetSettings(e.target.checked)}
              sx={{ mr: 1 }}
            />
            <Typography component="span">Use Preset Settings</Typography>
          </div>
        )}
        <Divider sx={{ m: 0 }} />
        <ChatbotSettingsForm />
        {view.view === VIEW_TYPES.COMMUNITY_CHATBOT_SETTINGS && (
          <ChatbotScript />
        )}
      </Box>
    </Box>
  );
};
export default ChatbotSettingsComponent;
